import Swal from "sweetalert2";
import Moment from "react-moment";
import { FaXmark } from "react-icons/fa6";
import { useEffect, useState } from "react";
import { FaCheck, FaRegCopy } from "react-icons/fa";
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { userServices } from "../../../APIServices/UserData/userServices";
import { accountServices } from "../../../APIServices/GlobalManagements/accountServices";

const UserList = ({ userId, organizationList, getMembers }) => {
  const [assignedAccount, setAssignedAccount] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [memberData, setMemberData] = useState("");
  const [loader, setLoader] = useState(false);

  const getSingleMember = async (userId) => {
    setLoader(true);
    let data = await userServices.getSingleMember(userId);
    setMemberData(data?.data || []);
    setAssignedAccount(data?.data?.assignedAccount || []);
    setLoader(false);
  };

  const getAccountList = async (adminId) => {
    let data = await accountServices.getAccountList(adminId, "active");
    setAccountList(data?.data || []);
  };

  const copyValue = (value) => {
    navigator.clipboard.writeText(String(value));
  };

  const handleCheckbox = (accountId, checked) => {
    if (checked) {
      setAssignedAccount((prev) => [...prev, accountId]);
    } else {
      setAssignedAccount((prev) => prev.filter((id) => id !== accountId));
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      setAssignedAccount(accountList.map((m) => m.accountId));
    } else {
      setAssignedAccount([]);
    }
  };

  const assignAccountMember = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Assign Selected Account of this Member?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Assign it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.adminId = memberData?.adminId;
        userData.userId = memberData?.userId;
        userData.assignedAccount = assignedAccount;
        userData.type = "assign";
        let data = await userServices.statusUpdateMember(userData);
        if (data?.statusCode === 200) {
          getMembers();
          getSingleMember(userId);
        }
      }
    });
  };

  const statusUpdateMember = async (userId, adminId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status === "active" ? "activate" : "deactivate"} this member?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status === "active" ? "activate" : "deactivate"} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.userId = userId
        userData.adminId = adminId
        userData.status = status
        userData.type = "status"
        let data = await userServices.statusUpdateMember(userData)
        if (data?.statusCode === 200) {
          getMembers();
          getSingleMember(userId);
        }
      }
    });
  };

  useEffect(() => {
    if (userId) {
      getSingleMember(userId);
    }
  }, [userId]);

  useEffect(() => {
    if (organizationList?.length === 1) {
      getAccountList(organizationList?.[0]?.adminId);
    }
  }, [organizationList]);

  return (
    <Container fluid className="mt-2">
      <Row className="justify-content-center">
        <Form.Group as={Col} xxl={6} xl={8} lg={10} md={12} sm={12}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
              <div className="hstack justify-content-between mb-4">
                <h5 className="mb-0">User Details</h5>
                <Button
                  onClick={() =>
                    statusUpdateMember(
                      memberData?.userId,
                      memberData?.adminId,
                      memberData?.status === "active" ? "inactive" : "active",
                    )
                  }
                  variant={
                    memberData?.status === "active"
                      ? "outline-danger"
                      : "outline-success"
                  }
                  size="sm"
                  disabled={assignedAccount?.length === 0}
                  className="hstack gap-1 rounded-1"
                  style={{ fontSize: 10 }}
                >
                  {memberData?.status === "active" ? <FaXmark /> : <FaCheck />}{" "}
                  {memberData?.status === "active" ? "Deactivate" : "Activate"}{" "}
                  Now
                </Button>
              </div>

              {/* Dynamic Details */}

              <div className="d-flex flex-column gap-3">
                <div className="d-flex justify-content-between">
                  <span className="text-muted">Name</span>
                  <strong>{memberData?.name}</strong>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-muted">Email</span>
                  <div className="d-flex align-items-center gap-2">
                    <strong>{memberData?.email}</strong>
                    <FaRegCopy
                      className="cursor-pointer text-muted"
                      title="Copy email"
                      onClick={() => copyValue(memberData?.email)}
                    />
                  </div>
                </div>

                {memberData?.phone && (
                  <div className="d-flex justify-content-between">
                    <span className="text-muted">Phone</span>
                    <strong>{memberData?.phone}</strong>
                  </div>
                )}

                <div className="d-flex justify-content-between">
                  <span className="text-muted">Designation</span>
                  <strong>{memberData?.designation}</strong>
                </div>

                <div className="d-flex justify-content-between">
                  <span className="text-muted">Role</span>
                  <strong>Member</strong>
                </div>

                <div className="d-flex justify-content-between">
                  <span className="text-muted">Joining Date | Time</span>
                  <strong>
                    <Moment format="DD MMM YYYY | HH:mm" withTitle>
                      {memberData?.createdAt}
                    </Moment>
                  </strong>
                </div>

                <div>
                  <Form.Label className="mb-3">Assign Accounts</Form.Label>
                  {accountList?.length > 0 && (
                    <Form.Check
                      type="checkbox"
                      label="Select All"
                      checked={assignedAccount?.length === accountList?.length}
                      onChange={(e) => handleSelectAll(e.target.checked)}
                      style={{ fontSize: 12 }}
                    />
                  )}
                  {accountList?.map((item, index) => (
                    <Form.Check
                      key={index}
                      type="checkbox"
                      disabled={item?.status === "inactive"}
                      label={item?.name}
                      checked={assignedAccount?.includes(item.accountId)}
                      onChange={(e) =>
                        handleCheckbox(item.accountId, e.target.checked)
                      }
                      style={{ fontSize: 12 }}
                    />
                  ))}
                  <Button
                    onClick={assignAccountMember}
                    variant="outline-primary"
                    size="sm"
                    disabled={assignedAccount?.length === 0}
                    className="hstack gap-1 rounded-1 mt-3"
                    style={{ fontSize: 10 }}
                  >
                    <FaCheck /> Assign Now
                  </Button>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Form.Group>
      </Row>
    </Container>
  );
};

export default UserList;
